var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterSocialInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 0H9.375C4.19813 0 0 4.19813 0 9.375V20.625C0 25.8019 4.19813 30 9.375 30H20.625C25.8019 30 30 25.8019 30 20.625V9.375C30 4.19813 25.8019 0 20.625 0ZM27.1875 20.625C27.1875 24.2437 24.2437 27.1875 20.625 27.1875H9.375C5.75625 27.1875 2.8125 24.2437 2.8125 20.625V9.375C2.8125 5.75625 5.75625 2.8125 9.375 2.8125H20.625C24.2437 2.8125 27.1875 5.75625 27.1875 9.375V20.625Z",
    fill: "#ACABBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 7.49969C10.8584 7.49969 7.50031 10.8578 7.50031 14.9997C7.50031 19.1416 10.8584 22.4997 15.0003 22.4997C19.1422 22.4997 22.5003 19.1416 22.5003 14.9997C22.5003 10.8578 19.1422 7.49969 15.0003 7.49969ZM15.0003 19.6872C12.4166 19.6872 10.3128 17.5834 10.3128 14.9997C10.3128 12.4141 12.4166 10.3122 15.0003 10.3122C17.5841 10.3122 19.6878 12.4141 19.6878 14.9997C19.6878 17.5834 17.5841 19.6872 15.0003 19.6872Z",
    fill: "#ACABBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0627 7.93715C23.6146 7.93715 24.062 7.48972 24.062 6.93778C24.062 6.38585 23.6146 5.93842 23.0627 5.93842C22.5107 5.93842 22.0633 6.38585 22.0633 6.93778C22.0633 7.48972 22.5107 7.93715 23.0627 7.93715Z",
    fill: "#ACABBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSocialInstagram);
export default __webpack_public_path__ + "static/media/footer__social__instagram.3548b3297968967ba8642aa739ba0b8f.svg";
export { ForwardRef as ReactComponent };